/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import noImage from 'src/assets/images/no-image.jpeg';
import { DEFAULT_CONFIGS } from 'src/constants';
// import { useAppContext } from 'src/context/appContext';
import useSearchQueryParams from 'src/hooks/useSearchQueryParams';
import '../index.scss';
import useTranslate from 'src/hooks/useTranslate';
import { useLanguageContext } from 'src/context/languageContext';

const onError = (e) => {
  e.target.src = noImage;
};

function AllGames({ games }) {
  // const {
  //   lobbyPageUrl,
  //   // player: { currency: currencyCode },
  // } = useAppContext();

  const { i18n } = useLanguageContext();

  // const groupCode = useSearchQueryParams(
  //   'groupCode',
  //   DEFAULT_CONFIGS.groupCode,
  // );
  const brandCode = useSearchQueryParams('oc', DEFAULT_CONFIGS.brandCode);

  const playerToken = useSearchQueryParams('t', DEFAULT_CONFIGS.playerToken);

  const [childWindow, setChildWindow] = useState(null);

  const handleOnClick = (e) => {
    const { url } = e.target.dataset;
    const language = i18n?.code;

    if (url) {
      // let redirectUrl = lobbyPageUrl;
      // if (window.location.search) {
      //   redirectUrl += window.location.search;
      // }

      // const playUrl = `${url}?playerToken=${playerToken}&brandCode=${brandCode}&groupCode=${groupCode}&language=${language}&currencyCode=${currencyCode}&redirectUrl=${encodeURIComponent(
      //   redirectUrl,
      // )}`;

      const playUrl = new URL(url);
      playUrl.searchParams.append('oc', brandCode);
      playUrl.searchParams.append('t', playerToken);
      playUrl.searchParams.append('l', language);
      // playUrl.searchParams.append('redirectUrl', redirectUrl);

      const newWindow = window.open(playUrl, '_blank');
      setChildWindow(newWindow);
    }
  };

  const translate = useTranslate();

  useEffect(() => {
    const handleMessage = (event) => {
      if (event && event.data?.action === 'CLOSE') {
        if (childWindow) {
          childWindow.close();
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [childWindow]);

  return (
    <div className="row">
      {games.length > 0 &&
        games.map((item) => (
          <div
            key={item.code}
            className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4"
          >
            <div className="lobby-card-container position-relative">
              {Boolean(item.isHotGame || item.isNewGame) && (
                <div className="lobby-card-label-container">
                  {Boolean(item.isNewGame) && <NewLabel />}
                  {Boolean(item.isHotGame) && <HotLabel />}
                </div>
              )}
              <Card>
                <Card.Img
                  variant="top"
                  src={item.preview || noImage}
                  height="100%"
                  width="100%"
                  onError={onError}
                  loading="lazy"
                />
                <Card.Body>
                  <Card.Title>{item.name}</Card.Title>
                  <Card.Text>{item.desc}</Card.Text>
                  <Button
                    variant="danger"
                    data-url={item.url}
                    onClick={handleOnClick}
                  >
                    {translate('common.text.playNow', 'Play Now')}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>
        ))}
    </div>
  );
}

AllGames.propTypes = {
  games: PropTypes.array,
};

function HotLabel() {
  const translate = useTranslate();

  return <div className="lobby-card-label hot-label">{translate('hot')}</div>;
}

function NewLabel() {
  const translate = useTranslate();
  return <div className="lobby-card-label new-label">{translate('new')}</div>;
}

export default AllGames;
